import { createRouter, createWebHistory } from "vue-router";
import Home from "@/views/Home.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
      meta: {
        title: "九火互娱 - 数字化转型引领者",
        description:
          "专注于网站开发、小程序开发、APP开发的技术服务提供商，助力企业数字化转型",
      },
    },
    {
      path: "/about",
      name: "About",
      component: () => import("./views/About.vue"),
      meta: {
        title: "关于我们 - 九火互娱",
        description: "九火互娱是专业的数字化转型服务商，提供AI智能解决方案",
      },
    },
    {
      path: "/services",
      name: "Services",
      component: () => import("./views/Services.vue"),
      meta: {
        title: "技术服务 - 九火互娱",
        description:
          "提供网站开发、小程序开发、H5开发、APP开发等全方位技术服务",
      },
    },
    {
      path: "/contact",
      name: "Contact",
      component: () => import("./views/Contact.vue"),
      meta: {
        title: "联系我们 - 九火互娱",
        description: "随时为您提供专业的技术支持和服务，欢迎咨询",
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// 路由切换时更新页面标题和描述
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.description) {
    document
      .querySelector('meta[name="description"]')
      .setAttribute("content", to.meta.description);
  }
  next();
});

export default router;
